import moment from 'moment';
import { get, isEmpty, isUndefined, omitBy } from 'lodash';
import { ColumnMappingOption, StudentProfileData } from '../types';

export function getUserDetails(
  user: any,
  fieldMappings: ColumnMappingOption[],
  selectedColumns: string[]
) {
  const userInfo: Record<string, any> = {};
  fieldMappings.forEach((mapping) => {
    let valueToSet = selectedColumns.includes(mapping.value)
      ? get(user, mapping.fieldMatchWithColumn ?? '', '')
      : undefined;

    if (mapping.fieldMatchWithColumn === 'personalDetails.dateOfBirth') {
      valueToSet = !isEmpty(valueToSet)
        ? moment(new Date(valueToSet)).format('DD-MM-YYYY')
        : undefined;
    }

    userInfo[mapping.label] = valueToSet;
  });

  return omitBy(userInfo, isUndefined);
}

export function transformStudentData(
  data: StudentProfileData[],
  studentFieldsMapping: ColumnMappingOption[],
  fatherFieldsMapping: ColumnMappingOption[],
  motherFieldsMapping: ColumnMappingOption[],
  selectedColumns: string[]
) {
  return data.map((record) => {
    const studentDetails = getUserDetails(
      record.student,
      studentFieldsMapping,
      selectedColumns
    );
    const fatherDetails = isEmpty(record.parents.father)
      ? {}
      : getUserDetails(
          record.parents.father,
          fatherFieldsMapping,
          selectedColumns
        );
    const motherDetails = isEmpty(record.parents.mother)
      ? {}
      : getUserDetails(
          record.parents.mother,
          motherFieldsMapping,
          selectedColumns
        );

    return omitBy(
      {
        id: record?.student?.id,
        ...studentDetails,
        ...fatherDetails,
        ...motherDetails,
        'Student Photo Uploaded?': !isEmpty(record.student.profile)
          ? 'Yes'
          : 'No',
        'Mother Photo Uploaded?': !isEmpty(record.parents?.mother?.profile)
          ? 'Yes'
          : 'No',
        'Mother Photo': undefined,
        'Father Photo Uploaded?': !isEmpty(record.parents?.father?.profile)
          ? 'Yes'
          : 'No',
        'Father Photo': undefined,
        'Guardian Photo Uploaded?': !isEmpty(
          record.student?.guardianInfo?.profile
        )
          ? 'Yes'
          : 'No',
        'Guardian Photo': undefined
      },
      isUndefined
    );
  });
}

export function transformedStudentDataForDownload(
  data: StudentProfileData[],
  studentFieldsMapping: ColumnMappingOption[],
  fatherFieldsMapping: ColumnMappingOption[],
  motherFieldsMapping: ColumnMappingOption[],
  selectedColumns: string[]
) {
  return data.map((record) => {
    const studentDetails = getUserDetails(
      record.student,
      studentFieldsMapping,
      selectedColumns
    );
    const fatherDetails = isEmpty(record.parents.father)
      ? {}
      : getUserDetails(
          record.parents.father,
          fatherFieldsMapping,
          selectedColumns
        );
    const motherDetails = isEmpty(record.parents.mother)
      ? {}
      : getUserDetails(
          record.parents.mother,
          motherFieldsMapping,
          selectedColumns
        );

    return omitBy(
      {
        ...studentDetails,
        ...fatherDetails,
        ...motherDetails,
        'Student Photo Uploaded?': !isEmpty(record.student?.profile)
          ? 'Yes'
          : 'No',
        'Student Photo': undefined,
        'Mother Photo Uploaded?': !isEmpty(record.parents?.mother?.profile)
          ? 'Yes'
          : 'No',
        'Mother Photo': undefined,
        'Father Photo Uploaded?': !isEmpty(record.parents?.father?.profile)
          ? 'Yes'
          : 'No',
        'Father Photo': undefined,
        'Guardian Photo Uploaded?': !isEmpty(
          record.student?.guardianInfo?.profile
        )
          ? 'Yes'
          : 'No',
        'Guardian Photo': undefined
      },
      isUndefined
    );
  });
}
